<template>
  <b-row class="h-100 align-items-center">
    <b-col
      cols="12"
      md="7"
    >
      <div>
        <b-btn
          v-if="!dataLoad && viewSearchBtn"
          variant="primary"
          class="d-flex align-items-center"
          @click="searchTable"
        >
          <feather-icon
            style="margin-right: 4px;"
            icon="SearchIcon"
          />
          <span>Search</span>
        </b-btn>
      </div>
    </b-col>
    <b-col
      cols="12"
      md="5"
    >
      <b-btn
        v-if="!dataLoad && viewSearchBtn"
        variant="outline-danger"
        class="w-100 h-100 d-flex align-items-center responsive-btn my-1"
        @click="removeSearchTable"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="icon-responsive"
        />
        <span class="text-responsive">Reset</span>
      </b-btn>
    </b-col>

  </b-row>
</template>

<script>

export default {
  name: 'SearchAction',
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    viewSearchBtn: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
  methods: {
    searchTable() {
      this.getAllData()
    },
    removeSearchTable() {
      this.$router.replace({ query: {} })
      window.location.reload()
    },
  },
}
</script>

<style>
.responsive-btn {
  font-size: clamp(12px, 1.5vw, 18px);
  padding: 0;
  max-width: 70px;
  min-height: 25px;
}

.icon-responsive {
  margin-right: 2px;
}

@media (max-width: 768px) {
  .responsive-btn {
    font-size: 14px;
  }
  .icon-responsive {
    width: 1em;
    height: 1em;
  }
}

@media (min-width: 1200px) {
  .responsive-btn {
    font-size: 12px;
    padding: 8px 9px;
  }
  .icon-responsive {
    width: 14px;
    height: 14px;
  }
  .text-responsive{
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
